import { render, staticRenderFns } from "./mdLink.vue?vue&type=template&id=25edae47&scoped=true"
import script from "./mdLink.vue?vue&type=script&lang=js"
export * from "./mdLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25edae47",
  null
  
)

export default component.exports